import icons from '@/assets/icons'
import React, { HTMLAttributes } from 'react'
import './index.less'

type SJCheckboxProps = HTMLAttributes<HTMLDivElement> & {
  checked: boolean
  title?: string
  onChange: (val: boolean) => void
}

const SJCheckbox: React.FC<SJCheckboxProps> = ({
  className,
  title,
  children,
  checked = false,
  onChange,
  ...props
}) => {
  const onClick = () => {
    onChange(!checked)
  }
  return (
    <div className={`sc-checkbox ${className ?? ''}`} {...props} onClick={onClick}>
      <img
        className="sc-checkbox-icon"
        src={checked ? icons.IconRadioChecked : icons.IconRadioDefault}
        alt=""
      />
      {title && <span className="sc-checkbox-title">{title}</span>}
      {children}
    </div>
  )
}

export default SJCheckbox
